import React from 'react';
import { graphql } from 'gatsby';
import reusableConfig from '~/data/config/reusable-images.json';

export type CheckmarksProps = {
  columns_bootstrap_rule: string;
  alignLeft?: boolean;
  marginTop?: number;
  marginBottom?: number;
  gap?: string;
  checkmarks: {
    name: string;
    text: string;
  }[];
};

const Checkmarks = ({
  alignLeft,
  marginTop,
  marginBottom,
  columns_bootstrap_rule,
  checkmarks,
  gap,
}: CheckmarksProps) => {
  return (
    <div
      className={`block__checkmarks ${alignLeft ? 'checkmarks--left' : ''}`}
      style={{
        marginTop: marginTop ? `${marginTop}rem` : '',
        marginBottom: marginBottom ? `${marginBottom}rem` : '',
        rowGap: gap ? `${gap}rem` : '',
      }}
    >
      {checkmarks?.map((checkmark, index) => {
        const checkmarkIcon = reusableConfig.checkmark_icons.find(
          icon => icon.name === checkmark.name
        );
        if (!checkmarkIcon) {
          return null;
        }
        return (
          <div
            key={index}
            className={`checkmark ${columns_bootstrap_rule}`}
          >
            <img
              className='checkmark__icon'
              src={checkmarkIcon.src}
              alt={checkmarkIcon.alt}
              title={checkmarkIcon.title || checkmarkIcon.alt}
            />
            <span
              className='checkmark__name'
              dangerouslySetInnerHTML={{ __html: checkmark.text }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Checkmarks;

export const checkmarksFragment = graphql`
  fragment CheckmarksFragment on Block {
    checkmarks_align_left
    columns_bootstrap_rule
    margin_top
    margin_bottom
    checkmarks {
      name
      text
    }
  }
`;
